// extracted by mini-css-extract-plugin
export default {"without_borders":"Footer_without_borders__AE26-","footer_container":"Footer_footer_container__y6tpA","footer_logo":"Footer_footer_logo__Ia2S4"};